<template>
  <div class="content">
    <div class="filter">
      <el-date-picker v-model="date" :clearable="false" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="handleDatePick" style="width:300px"></el-date-picker>
      <!-- <el-select v-model="params.equipment" clearable placeholder="设备" @change="resetPage"  style="width:160px">
        <el-option label="移动设备" :value="1" />
        <el-option label="平板设备" :value="2" />
        <el-option label="桌面设备" :value="3" />
      </el-select> -->
      <!-- <span class="update-time">更新时间：{{params.modifyDate}}</span> -->
      <!-- <el-button>重新统计</el-button> -->
      <!-- <el-button @click="importExportFile">数据导出</el-button> -->
      <el-input v-model="params.search" clearable placeholder="输入网页">
        <el-button slot="append" icon="el-icon-search" @click="resetPage" />
      </el-input>
    </div>

    <el-table :data="statisticsList" @sort-change="sortTable" height="calc(100vh - 200px)">
      <el-table-column  label="网页" min-width="250" fixed>
        <template slot-scope="{row}">
          <el-button  type="text"  @click="jumpView(row.fullPath)">
             <span class="jump">{{row.fullPath}}</span>
            </el-button>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="browseQty" label="网页浏览量" min-width="120" align="right"></el-table-column>
      <el-table-column sortable="custom" prop="userTotal" label="用户数" min-width="120" align="right"></el-table-column>
      <el-table-column sortable="custom" prop="dwellTime" label="平均页面停留时间" min-width="120" align="right">
        <template v-slot="{ row }">
          <span>{{ row.dwellTime }}s</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="rate" label="跳出率" min-width="120" align="right">
        <template v-slot="{ row }">
          <span>{{ row.rate*100 | round }}%</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background :current-page="params.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { dateFormat } from '@/utils/date'
import moment from "moment";
import _ from "lodash";
export default {
  name: 'report_pageStatistics',
  data() {
    return {
      total: 0,
      date: [moment().subtract("days", 6), moment()],
      statisticsList: [],
      params: {
        pageNumber: 1,
        pageSize: 20,
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setHours(0, 0, 0, 0), start.setHours(23, 59, 59, 999));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date().setHours(23, 59, 59, 999) - 24 * 3600000;
            const start = new Date().setHours(0, 0, 0, 0) - 24 * 3600000;
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近七天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上个月',
          onClick(picker) {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).getTime();
            const end = new Date(new Date().getFullYear(), new Date().getMonth(), 0).getTime() + 24 * 3600000 - 60;
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          return time.getTime() > new Date().setHours(23, 59, 59, 999);
        },
      }
    }
  },
  computed: {
    getSortType() {
      return (type) => {
        switch (type) {
          case 'ascending':
            return 'asc'
          case 'descending':
            return 'desc'
          case null:
            return undefined
        }
      }
    },
    getSortName() {
      return (name) => {
        switch (name) {
          case 'browseQty':
            return 1
          case 'userTotal':
            return 2
          case 'dwellTime':
            return 3
          case 'rate':
            return 4
          case null:
            return undefined
        }
      }
    }
  },
  created() {
    if (this.$route.query.startTime) {
      this.date = [
        Number(this.$route.query.startTime),
        Number(this.$route.query.endTime),
      ];
      this.$set(this.params, 'startTime', dateFormat(this.date[0], 'yyyy-MM-dd').replace(/-/g, ''))
      this.$set(this.params, 'endTime', dateFormat(this.date[1], 'yyyy-MM-dd').replace(/-/g, ''))
    }
    this.$set(this.params, 'startTime', dateFormat(this.date[0], 'yyyy-MM-dd').replace(/-/g, ''))
    this.$set(this.params, 'endTime', dateFormat(this.date[1], 'yyyy-MM-dd').replace(/-/g, ''))
    this.dashboardPage()
  },
  methods: {
    //数据导出
    importExportFile() {
      API.importExportFile(this.exportForm).then(() => {
        this.$message.success('数据导出成功,请前往导入导出中心查看进度')
      })
    },

    //时间筛选用户概览
    handleDatePick(value) {
      this.$set(this.params, 'startTime', (value && value.length === 2) ? dateFormat(value[0], 'yyyy-MM-dd').replace(/-/g, '') : undefined)
      this.$set(this.params, 'endTime', (value && value.length === 2) ? dateFormat(value[1], 'yyyy-MM-dd').replace(/-/g, '') : undefined)
      this.resetPage()
    },

    jumpView(url){//
      window.open(process.env.VUE_APP_KAKACLO_URL+url);//打开新网页跳转至新网页
    },

    dashboardPage() {
      API.dashboardPage(this.params).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.statisticsList = res.data.list
        this.total = res.data.total
      })
    },

    resetPage() {
      this.params.pageNumber = 1
      this.dashboardPage()
    },
    sizeChange(size) {
      this.params.pageSize = size
      this.dashboardPage()
    },
    //用户概览分页
    pageChange(page) {
      this.params.pageNumber = page
      this.dashboardPage()
    },

    sortTable({ prop, order }) {
      this.params.orderType = this.getSortName(prop)
      this.params.order = this.getSortType(order)
      this.resetPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  min-width: 1200px;
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
  .jump:hover{
    text-decoration: underline;
  }
}
.range-num {
  display: inline-block;
  margin-right: 16px;
}
.update-time {
  display: inline-block;
  margin: 0 16px;
}

.avatar {
  width: 178px;
  height: 178px;
  object-fit: cover;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/deep/.el-range-separator {
  min-width: 20px;
}
.info-list {
  height: 30px;
  padding-left: 22px;
  color: #99c41c;
  font-size: 16px;
  span {
    display: inline-block;
    margin-right: 16px;
  }
}
</style>>
